import { render, staticRenderFns } from "./PrivateSystem.vue?vue&type=template&id=3b54d3b0&scoped=true"
import script from "./PrivateSystem.vue?vue&type=script&lang=js"
export * from "./PrivateSystem.vue?vue&type=script&lang=js"
import style0 from "./PrivateSystem.vue?vue&type=style&index=0&id=3b54d3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54d3b0",
  null
  
)

export default component.exports